import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContextScope } from '../../internal/context/scoped-context';
import { DIALOG_NAME, PORTAL_NAME } from './constants';
var _createContextScope = createContextScope(DIALOG_NAME),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createDialogContext = _createContextScope2[0],
  createDialogScope = _createContextScope2[1];
export { createDialogContext, createDialogScope };
var _createDialogContext = createDialogContext(DIALOG_NAME),
  _createDialogContext2 = _slicedToArray(_createDialogContext, 2),
  DialogProvider = _createDialogContext2[0],
  useDialogContext = _createDialogContext2[1];
export { DialogProvider, useDialogContext };
var _createDialogContext3 = createDialogContext(PORTAL_NAME, {
    forceMount: undefined
  }),
  _createDialogContext4 = _slicedToArray(_createDialogContext3, 2),
  PortalProvider = _createDialogContext4[0],
  usePortalContext = _createDialogContext4[1];
export { PortalProvider, usePortalContext };